import http from "./http";

// /* =========================
//    ALL TM + SALES USERS
// ========================= */
// export const getAllUsers = async () => {
//   const res = await http.post(`/tm_sale_all_user?action=all`);
//   return res.data?.data || [];
// };

// /* =========================
//    ADMIN DASHBOARD + TM REPORT
// ========================= */
// export const getTeamReport = async () => {
//   const res = await http.post(`/full_details`);
//   return res.data?.data || {};
// };

// /* =========================
//    TM FULL DETAILS BY ID
// ========================= */
// export const getTmReportById = async (tmId) => {
//   const res = await http.post(
//     `/all-tmleader-details`,
//     null,
//     {
//       params: { tm_id: tmId },
//     }
//   );
//   return res.data?.data || null;
// };




/* =========================
   ALL TM + SALES USERS
========================= */
export const getAllUsers = async () => {
  const res = await http.post(`/tm_sale_all_user?action=all`);
  return res.data?.data || [];
};

/* =========================
   ADMIN DASHBOARD + TM REPORT
========================= */
export const getTeamReport = async () => {
  const res = await http.post(`/full_details`);
  return res.data?.data || {};
};

/* =========================
   TM FULL DETAILS BY ID
========================= */
export const getTmReportById = async (tmId) => {
  const res = await http.post(
    `/all-tmleader-details`,
    null,
    {
      params: { tm_id: tmId },
    }
  );
  return res.data?.data || null;
};

/* =========================
   USER PERFORMANCE REPORT
========================= */
export const getUserPerformanceReport = async (params = {}) => {
  const { user_id = null, role = null, date_range = [], status = null } = params;
  
  const queryParams = new URLSearchParams();
  queryParams.append('action', 'get_report');
  if (user_id) queryParams.append('user_id', user_id);
  if (role) queryParams.append('role', role);
  if (status) queryParams.append('status', status);
  if (date_range.length === 2) {
    queryParams.append('start_date', date_range[0]);
    queryParams.append('end_date', date_range[1]);
  }
  
  const res = await http.get(`/reports?${queryParams.toString()}`);
  return res.data || null;
};

/* =========================
   USER PERFORMANCE REPORT BY ID (Alias)
========================= */
export const getReportByUserId = async (userId, role = null) => {
  const params = { user_id: userId };
  if (role) params.role = role;
  return await getUserPerformanceReport(params);
};

/* =========================
   ALL USERS REPORT (TM Role)
========================= */
export const getAllTmReport = async () => {
  const params = { role: 'tm' };
  return await getUserPerformanceReport(params);
};

/* =========================
   ALL SALES USERS REPORT
========================= */
export const getAllSalesReport = async () => {
  const params = { role: 'sales' };
  return await getUserPerformanceReport(params);
};

/* =========================
   GET REPORT WITH DATE RANGE
========================= */
export const getReportWithDateRange = async (startDate, endDate, role = null, userId = null) => {
  const params = {
    date_range: [startDate, endDate],
    role: role,
    user_id: userId
  };
  return await getUserPerformanceReport(params);
};